import { all, takeLatest } from "redux-saga/effects";
import processAction from "../../../../utils/processAction";
import { actionTypes as overheadActionTypes } from "./reducer";
import {
  getOverhead as getOverheadService,
  createOverhead as createOverheadService,
  copyOverhead as copyOverheadService,
  updateOverhead as updateOverheadService,
  deleteOverhead as deleteOverheadService
} from "./service";

function* getOverheads({ company_id, params }) {
  yield processAction({
    params: { company_id, params },
    service: getOverheadService,
    success: overheadActionTypes.GET_OVERHEAD_SUCCESS,
    failed: overheadActionTypes.GET_OVERHEAD_FAILED
  })
}

function* createOverhead({ payload }) {
  yield processAction({
    params: payload,
    service: createOverheadService,
    success: overheadActionTypes.CREATE_OVERHEAD_SUCCESS,
    failed: overheadActionTypes.CREATE_OVERHEAD_FAILED
  })
}

function* copyOverhead({ company_id, body }) {
  yield processAction({
    params: { company_id, body },
    service: copyOverheadService,
    success: overheadActionTypes.COPY_OVERHEAD_SUCCESS,
    failed: overheadActionTypes.COPY_OVERHEAD_FAILED
  })
}

function* updateOverhead({ company_id, overhead_id, body }) {
  yield processAction({
    params: { company_id, overhead_id, body },
    service: updateOverheadService,
    success: overheadActionTypes.UPDATE_OVERHEAD_SUCCESS,
    failed: overheadActionTypes.UPDATE_OVERHEAD_FAILED
  })
}

function* deleteOverhead({ company_id, overhead_id }) {
  yield processAction({
    params: { company_id, overhead_id },
    service: deleteOverheadService,
    success: overheadActionTypes.DELETE_OVERHEAD_SUCCESS,
    failed: overheadActionTypes.DELETE_OVERHEAD_FAILED
  })
}



function* watchOverhead() {
  yield all([
    takeLatest(overheadActionTypes.GET_OVERHEAD, getOverheads),
    takeLatest(overheadActionTypes.CREATE_OVERHEAD, createOverhead),
    takeLatest(overheadActionTypes.COPY_OVERHEAD, copyOverhead),
    takeLatest(overheadActionTypes.UPDATE_OVERHEAD, updateOverhead),
    takeLatest(overheadActionTypes.DELETE_OVERHEAD, deleteOverhead)
  ])
}

export default [watchOverhead()]




// WEBPACK FOOTER //
// ./src/modules/company/pages/overhead/saga.js